import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

import type {ExportColumn} from '../types/exportTypes';

export type ExportPdfTableProps<TRecord> = {
  columns: ExportColumn<TRecord>[];
  records: TRecord[];
};

const ExportPdfTable = <TRecord,>({
  columns,
  records,
}: ExportPdfTableProps<TRecord>) => (
  <Table className="text-xs">
    <TableHeader>
      <TableRow>
        {columns.map(column => (
          <TableHead key={column.header}>{column.header}</TableHead>
        ))}
      </TableRow>
    </TableHeader>
    <TableBody>
      {records.map((record, index) => (
        <TableRow key={index} className="print:break-inside-avoid">
          {columns.map(column => (
            <TableCell key={column.header}>{column.value(record)}</TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default ExportPdfTable;
